// extracted by mini-css-extract-plugin
module.exports = {"RelatedMaterials":"RelatedMaterials_RelatedMaterials__o3bJQ","container":"RelatedMaterials_container__Gdkpp","box":"RelatedMaterials_box__jdrpQ"};